import {
    UPDATEKYCLABELPARTNER_SUCCESS,
    UPDATEKYCLABELPARTNER_FAILED,
    RESET_UPDATEKYCLABELPARTNER,
    LOADING_UPDATEKYCLABELPARTNER,
    NETWORK_ERROR_UPDATEKYCLABELPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateKycLabel = () => {
    return { type: RESET_UPDATEKYCLABELPARTNER };
};

const updateKycLabelList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEKYCLABELPARTNER });
    await partnerServices
        .post("updatekycLabel", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateKycLabelsuccess(res.data));
                    break;
                default:
                    dispatch(updateKycLabelFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEKYCLABELPARTNER, payload: err });
        });
};
function updateKycLabelsuccess(data) {
    return {
        type: UPDATEKYCLABELPARTNER_SUCCESS,
        payload: data,
    };
}
function updateKycLabelFailed(data) {
    return {
        type: UPDATEKYCLABELPARTNER_FAILED,
        payload: data,
    };
}

export { resetUpdateKycLabel, updateKycLabelList };